import Vue from 'vue'
import VueStash from 'vue-stash' // simple state management

Vue.use(VueStash)
